import React from 'react';

const PermissionTable = () => {
  return (
    <div>
      <h4>Permission Table</h4>
    </div>
  );
};

export default PermissionTable;
